import HttpClienteToken from '../../services/HttpClientToken';

import { PuestoProps } from '../../interfaces/catalogos/PuestoInterface';

export const Puesto = () => {

    return new Promise<PuestoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Puesto/', token)
            .then( ({ data } : { data : PuestoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerPuestos = () => {

    return new Promise<PuestoProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Puesto/ObtenerPuestos', token)
            .then( ({ data } : { data : PuestoProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarPuesto = ( params: PuestoProps ) => {

    return new Promise<PuestoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Puesto/Actualizar', params, token)
            .then( ({ data } : { data : PuestoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idPuesto: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarPuesto = ( params: PuestoProps ) => {

    return new Promise<PuestoProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Puesto/Agregar', params, token)
            .then( ({ data } : { data : PuestoProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idPuesto: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}